import React from 'react';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';
import { Element } from 'react-scroll';
import { Link } from 'react-router-dom';

const CaseStudy = () => {
  const outcome1 = "30%";
  const outcome2 = "40%";
  const outcome3 = "92%";
  const outcome4 = "25%";

  return (
    <>
      <Element
        name="CaseStudy"
        className="datatalent-section-gap mea-key-features"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center"
                title = "Case Study"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              {/* <p className="text-center">How we helped a precision manufacturing company embrace Industry 4.0.</p> */}
            </div>
            <div className="single-case-study-card d-flex flex-column flex-md-row align-items-center justify-content-between bg-white p-4 p-md-5">
              <div className="col-12 col-md-8">
                <div className="d-flex flex-row align-items-center justify-content-start gap-4">
                  <div className="icon-image-box h-100">
                    <img src={`${process.env.PUBLIC_URL}/images/icons/factory.svg`} alt="factory" />
                  </div>
                  <div className="title-and-subtitle">
                    <h5 className="mb-0 lh-1">Pathoscan</h5>
                    <p className="mb-0">Accelerating Crop Disease Detection with Pathoscan</p>
                  </div>
                </div>
                <h6 className="mt-5 mb-4">The Challenge</h6>
                <p>Pathoscan aimed to improve early detection of crop diseases using their PathoBox assay kits. Traditional lab-based analysis was slow, requiring expert validation and causing delays in intervention during narrow disease windows.</p>
                <h6 className="mb-4">Our Approach</h6>
                <p className="mb-0">We collaborated with Pathoscan to build a scalable cloud ML pipeline that processes image data from biochemical assays. Our team implemented advanced image preprocessing, reaction classification, and developed a highly accurate machine learning model for real-time pathogen detection.</p>
                <h6 className="mt-5 mb-4">Key Results</h6>
                <ul>
                  <li>Achieved 92% accuracy in pathogen detection</li>
                  <li>Reduced processing time to under 5 seconds</li>
                  <li>Model demonstrated 91% AUC score, ensuring reliable predictions</li>
                </ul>
                <h6 className="mb-4">Impact</h6>
                <p className="mb-0">The project laid the foundation for Pathoscan's transition to a field-ready, automated detection tool, reducing reliance on manual interpretation and enabling scalable deployment across farms.</p>
              </div>
              <div className="col-12 col-md-4 mt-4 md-mt-0">
                <div className="single-case-study-stats ms-md-4 p-4 p-md-5">
                  <h6>Key Outcomes</h6>
                  <div className="d-flex flex-row align-items-center justify-content-between">
                    <small>Crop Yield Accuracy</small>
                    <small>{outcome1}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="reduced-downtime-progress" style={{width: outcome1}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>Reduction in Water & Energy Use</small>
                    <small>{outcome2}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="quality-improvement-progress" style={{width: outcome2}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>Accuracy in Pathogen Detection</small>
                    <small>{outcome3}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="oee-increase-progress" style={{width: outcome3}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>Reduction in Crop Loss</small>
                    <small>{outcome4}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="roi-timeline-progress" style={{width: outcome4}}></div>
                  </div>
                    <Link className="edu-btn btn-primary btn-small w-100 text-center mt-5" to="/contact-us">Request Full Case Study</Link>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default CaseStudy;